<script setup lang="ts">
import {computed} from "vue";
import {Component} from "../types.ts";
import useStore from "../store.ts";
import {buildAssetUrl} from "../utils/AssetUrl.ts";

// A playlist SOUND step: plays the file for as long as the step is mounted; nothing is displayed.
const props = defineProps<{
  item: Component
}>();

const store = useStore();
// Reactive: the content base only exists once the authenticate reply lands.
const environment = computed(() => store.device_settings?.content_url ?? "");
const soundSrc = computed(() => buildAssetUrl(props.item.published?.src, environment.value));
</script>

<template>
  <div :id="`${item.props.id}`" :style="item.props.style">
    <audio :src="soundSrc" autoplay="true" />
  </div>
</template>
